import { useDasBalanceContext } from '@did/das-app-context'
import LogoSvg from '@did/das-assets/images/icon/balance-logo.svg'
import { IBaseProps } from '@did/types'
import { TopNav, TopNavMobile } from '@did/uikit'
import React, { useMemo } from 'react'
import { LayoutRight } from './layout-right'
import { cn } from '@did/tools'
import { BackButton } from '@did/das-app-components'
import { SUB_TABS } from '@did/das-balance-constants'

export const BaseLayout: React.FC<IBaseProps> = ({ children }) => {
  const { router, tt } = useDasBalanceContext()

  const logo = (
    <LogoSvg
      className="inline-flex w-[150px] md:w-[160px] cursor-pointer"
      onClick={() => {
        router.push('/ckb')
      }}
    />
  )

  const backButton = useMemo(() => {
    return (
      <BackButton
        onClick={() => {
          if (['/credits/record'].includes(router?.pathname)) {
            router.push('/credits')
          } else {
            router.back?.()
          }
        }}
      />
    )
  }, [router?.pathname])

  const showBackButton = useMemo(() => {
    return ['/credits/record', '/credits/topup'].includes(router?.pathname)
  }, [router?.pathname])

  const onTabChange = (value: string) => {
    if (value === SUB_TABS.ckb) {
      router.push?.('/ckb')
    } else if (value === SUB_TABS.credits) {
      router.push?.('/credits')
    }
  }

  return (
    <div
      className={cn(
        'flex flex-col min-h-screen bg-no-repeat bg-center bg-cover bg-gray-50'
      )}
    >
      <TopNavMobile
        className={cn('md:hidden bg-slate-50/80 backdrop-blur-[25px]')}
        Logo={showBackButton ? backButton : logo}
        Right={LayoutRight}
      />
      <TopNav
        className={cn('hidden md:block bg-slate-50/80 backdrop-blur-[25px]')}
        Logo={showBackButton ? backButton : logo}
        Right={LayoutRight}
      />
      <div className="sticky top-[62px] md:top-[86px] z-10 flex justify-center items-center gap-8 bg-gray-100/80 border-t border-b border-slate-600/10 backdrop-blur-[25px]">
        <span
          className={cn(
            'w-16 text-center cursor-pointer text-base hover:opacity-70 py-2',
            router.pathname.includes('/ckb')
              ? 'text-zinc-800 font-semibold'
              : 'text-gray-600 font-normal'
          )}
          onClick={() => onTabChange(SUB_TABS.ckb)}
        >
          {tt('CKB')}
        </span>
        <span
          className={cn(
            'w-16 text-center cursor-pointer text-base hover:opacity-70 py-2',
            router.pathname.includes('/credits')
              ? 'text-zinc-800 font-semibold'
              : 'text-gray-600 font-normal'
          )}
          onClick={() => onTabChange(SUB_TABS.credits)}
        >
          {tt('Credits')}
        </span>
      </div>
      {children}
    </div>
  )
}
